// Autogenerated file
export const tripSheetMedicalInspectionTypesEnum = {
    PreTrip: "PreTrip",
    PreShift: "PreShift",
    PostTrip: "PostTrip",
    PostShift: "PostShift",
};
export const tripSheetMedicalInspectionTypes = [
    { label: "Предрейсовый", value: "PreTrip" },
    { label: "Предсменный", value: "PreShift" },
    { label: "Послерейсовый", value: "PostTrip" },
    { label: "Послесменный", value: "PostShift" },
];
